export const AI_SCRUB_OVERWRITE_WARNING =
  'Each time you run the agent, the previous evaluation results are overwritten with the latest results.';
